import React from 'react';
import cn from 'classnames';
import { number, string, func, bool, node } from 'prop-types';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import { currencyToSign } from '../../../../utils/utils';
import { FMessage } from '../../../../hoc/IntlComponents';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  onSort: func,
  inverse: bool,
  is_sortable: bool,
  postfix: node,
  sortable: bool,
  order: number,
};
const defaultProps = {
  id: 0,
  onSort() {},
};

const getPostFix = (title, postfix, type) => {
  if (type === 'webmaster_id') {
    return <FMessage id="statistics.table.head.cell.webmaster.id" />;
  }
  return postfix ? `${title}, ${currencyToSign(postfix)}` : title;
};

const getTitle = (id, title, postfix, type, isInConversionsTable) => {
  if (isInConversionsTable) return getPostFix(title, postfix, type);

  switch (id) {
    case 27:
    case 31:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon green"
          icon="check-rounded"
        >
          {title}
        </Tooltip>
      );
    case 126:
    case 127:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon purple"
          icon="dots"
        >
          {title}
        </Tooltip>
      );
    case 28:
    case 32:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon orange"
          icon="wait"
        >
          {title}
        </Tooltip>
      );
    case 29:
    case 33:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon red"
          icon="cross-rounded"
        >
          {title}
        </Tooltip>
      );
    case 30:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon grey"
          icon="denied"
        >
          <FMessage id="statistics.fields.trash.theme_3" />
        </Tooltip>
      );
    case 36:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon blue"
          icon="approve"
        >
          {title}
        </Tooltip>
      );
    case 38:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon purple"
          icon="circle-arrow-right"
        >
          {title}
        </Tooltip>
      );
    case 39:
      return (
        <Tooltip
          id={`statistics-table-${id}`}
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          className="statistics-table-icon blue"
          icon="approve"
        >
          {title}
        </Tooltip>
      );
    default:
      return getPostFix(title, postfix, type);
  }
};

const StatisticsTableField = ({
  id,
  title,
  postfix,
  is_sortable,
  sorted,
  order,
  inverse,
  onSort,
  type,
  isInConversionsTable,
  isRendering = true,
}) => {
  return isRendering ? (
    <th>
      {is_sortable ? (
        <a
          role="button"
          className={cn('link-sort', {
            asc: sorted && order > 0,
            desc: sorted && order < 0,
          })}
          onClick={e => onSort(id, inverse, e)}
        >
          {getTitle(id, title, postfix, type, isInConversionsTable)}
        </a>
      ) : (
        <span>{getTitle(id, title, postfix, type, isInConversionsTable)}</span>
      )}
    </th>
  ) : null;
};

StatisticsTableField.propTypes = propTypes;
StatisticsTableField.defaultProps = defaultProps;

export default StatisticsTableField;
